import { ConfigService } from './configService';
import { getConfig } from '../config';
import { Logger } from '../utils/logger';
import { RedirectError } from '../errors/RedirectError';

export class RedirectService {
  private static instance: RedirectService;
  private readonly configService: ConfigService;

  private constructor() {
    this.configService = ConfigService.getInstance();
  }

  public static getInstance(): RedirectService {
    if (!RedirectService.instance) {
      RedirectService.instance = new RedirectService();
    }
    return RedirectService.instance;
  }

  public redirectToApp(): void {
    const redirectUrl = this.getAppUrl();
    Logger.logInfo(`Redirecting to app: ${redirectUrl}`);
    globalThis.location.href = redirectUrl;
  }

  private getAppUrl(): string {
    const app = this.configService.getActiveApplication()?.toLowerCase();
    const companyCode = this.configService.getOrganizationCode()?.toLowerCase();
    const config = getConfig();

    switch (app) {
      case 'erp':
        return config.TF_ERP_URL;
      case 'admin':
        return config.TF_ADM_URL;
      case 'hub':
        return this.getHubUrl(companyCode, config);
      default:
        throw new RedirectError(`Application ${app} is not supported`);
    }
  }

  private getHubUrl(companyCode: string | undefined, config: ReturnType<typeof getConfig>): string {
    switch (companyCode) {
      case 'tf':
        return config.TF_HUB_URL;
      case 'rtsg':
        return config.RTSG_HUB_URL;
      case 'tio':
        return config.TIO_HUB_URL;
      case 'dbg':
        return config.DBG_HUB_URL;
      default:
        throw new RedirectError(`Company ${companyCode} is not supported`);
    }
  }
}
